import { productConstants } from '../Constants';
import { productServices } from '../Services';

const productActions = {
	fetchProducts,
	fetchCategories,
};

function fetchProducts(req = {}) {
	return (dispatch) => {
		dispatch(request());
		productServices.getProducts(req).then(
			(res) => {
				const { data } = res;
				dispatch(success(data));
			},
			(error) => {
				dispatch(failure(error));
			}
		);
	};

	function request(payload) {
		return {
			type: productConstants.FETCH_PRODUCTS_REQUEST,
			payload,
		};
	}
	function success(payload) {
		return {
			type: productConstants.FETCH_PRODUCTS_SUCCESS,
			payload,
		};
	}
	function failure(payload) {
		return {
			type: productConstants.FETCH_PRODUCTS_FAILURE,
			payload,
		};
	}
}

function fetchCategories(
	req = {
		id: '',
	}
) {
	return (dispatch) => {
		dispatch(request());
		productServices.getCategories(req).then(
			(data) => {
				dispatch(success(data));
			},
			(error) => {
				dispatch(failure(error));
			}
		);
	};

	function request(payload) {
		return {
			type: productConstants.FETCH_CATEGORIES_REQUEST,
			payload,
		};
	}
	function success(payload) {
		return {
			type: productConstants.FETCH_CATEGORIES_SUCCESS,
			payload,
		};
	}
	function failure(payload) {
		return {
			type: productConstants.FETCH_CATEGORIES_FAILURE,
			payload,
		};
	}
}

export default productActions;
